/*  For the lock to work, the target combo must be a string of 4 digits from 1 to 4 or 5 digits from 1 to 5, with a repeated digit.
 The currently entered combo has the same constraints.
 */
function ComboLock(room, target, combo) {
    /*
     Target and combo must both have the same number of digits, either 4 or 5.
     Digits may range from 1 to the number of digits in the lock.
     The combo as presently entered can have any set of digits from that range.
     Valid target combinations always include a repeated digit.
     */
    this.room = room;
    this.target = target;
    this.combo = parseInt(combo);

    /*  Each digit has two sprites so we can dissolve from one to the other.
     N.B. There might be a lazier way to do transitions.
     Sprites 0 and 1 are available at each of the 4 or 5 positions on the lock.
     The currently showing digit is using sprite digitSprite[iSprite].
     When it changes, it will dissolve to sprite 1 - digitSprite[iSprite];
     */
    this.digitSprite = [0, 0, 0, 0, 0];
}

ComboLock.prototype.solved =
    function () {
        return this.combo == this.target;
    };

ComboLock.prototype.entityManifestSpec =
    function () {
        return [
            {full_id: 'combo-pad-frames', full_src: 'combo_pad-frames.png'},
            {full_id: 'combo-digits', full_src: 'combo_digits.png'},
            {full_id: 'combo-digit-sound', full_src: 'sounds/soft_click.wav'}
        ];
    };

ComboLock.prototype.entityLoad =
    function () {
        this.loadDigits();
        this.loadPads();
        this.sndOpenGate = this.room.world.queue.getResult('combo-digit-sound');
    };

ComboLock.prototype.loadDigits =
    function () {
        var queue = this.room.world.queue;

        this.readOut = new createjs.Container();
        this.readOut.name = 'readout';

        var digitAnimData = {
            images: [queue.getResult('combo-digits')],
            frames: {width: 38, height: 56, count: 5},
            animations: {d1: 0, d2: 1, d3: 2, d4: 3, d5: 4}
        };

        this.artDigitFrames = new createjs.SpriteSheet(digitAnimData);

        var sprite;

        for (var i = 0; i < this.numDigits(); i++) {
            var pos = this.posDigit(i);

            for (j = 0; j < 2; j++) {
                sprite = ujPut(new createjs.Sprite(this.artDigitFrames, 'd' + this.sCombo().substr(i, 1)), pos.x, pos.y, 'digit-' + i + '-' + j);
                sprite.alpha = j == this.digitSprite[i] ? 1 : 0;
                this.readOut.addChild(sprite);
            }
        }

        this.room.reg(this.readOut);
    };

ComboLock.prototype.loadPads =
    function () {
        var queue = this.room.world.queue;

        this.pads = new createjs.Container();

        var padAnimData = {
            images: [queue.getResult('combo-pad-frames')],
            frames: {width: 73, height: 29, count: 2},
            animations: {idle: 0, active: {frames: [1, 0], speed: 0.5, next: 'idle'}}
        };

        this.artPadFrames = new createjs.SpriteSheet(padAnimData);

        var sprite;

        for (var i = 0; i < this.numDigits(); i++) {
            var pos = this.posPad(i);

            sprite = ujPut(new createjs.Sprite(this.artPadFrames, 'idle'), pos.x, pos.y, 'pad-' + i);

            sprite.gameCursor = 'action';

            sprite.on('click', function (evt, data) {

                this.pads.children[data.iPad].gotoAndPlay('active');
                this.hitPad(data.iPad);

            }, this, false, {iPad: i});

            this.pads.addChild(sprite);
        }

        this.room.reg(this.pads);
    };

ComboLock.prototype.numDigits =
    function () {
        return this.sCombo().length;
    };

ComboLock.prototype.hitPad =
    function (i) {
        var nNext = this.comboNextDigit(i);

        if (nNext != this.comboDigit(i)) {
            var cur = this.readOut.getChildByName(this.digitSpriteName(i, this.digitState(i)));
            this.toggleDigitState(i);
            var suc = this.readOut.getChildByName(this.digitSpriteName(i, this.digitState(i)));

            suc.gotoAndStop('d' + nNext);

            createjs.Tween.get(cur).to({alpha: 0}, 400);
            createjs.Tween.get(suc).to({alpha: 1}, 500);

            createjs.Sound.play('combo-digit-sound', {volume: 0.2});
            this.hitComboDigit(i);

            if (this.solved()) {
                this.room.solved();
                this.room.leave();
            }
        }
    };

ComboLock.prototype.digitState =
    function (i) {
        return parseInt(this.digitSprite[i] ? '1' : '0');
    };

ComboLock.prototype.toggleDigitState =
    function (i) {
        var ds = this.digitSprite;
        this.digitSprite = ds.slice(0, i).concat(ds[i] ? [0] : [1], ds.slice(i + 1));
    };

ComboLock.prototype.digitSpriteName =
    function (i, j) {
        return 'digit-' + i + '-' + (j ? 1 : 0);
    };

ComboLock.prototype.digitSprite =
    function (i, alt) {
        if (alt)
            return this.readOut.getChildByName('digit-' + i + '-' + (1 - this.digitSprite[i]));
        else
            return this.readOut.getChildByName('digit-' + i + '-' + this.digitSprite[i]);
    };


ComboLock.prototype.hitComboDigit =
    function (i) {
        var c = this.sCombo();
        this.combo = parseInt(c.slice(0, i) + this.comboNextDigit(i) + c.slice(i + 1));
    };

ComboLock.prototype.comboDigit =
    function (i) {
        return parseInt(this.sCombo().charAt(i));
    };

ComboLock.prototype.hasDigit =
    function (n) {
        return this.sCombo().indexOf(n) >= 0;
    };

ComboLock.prototype.sCombo =
    function () {
        return '' + this.combo;
    }

ComboLock.prototype.comboNextDigit =
    function (i) {
        for (var nNext = 1 + this.comboDigit(i) % this.numDigits(); true; nNext = nNext >= this.numDigits() ? 1 : 1 + nNext) {
            if (i + 1 == nNext || this.hasDigit(nNext))
                return nNext;
        }
    };

ComboLock.prototype.posDigit =
    function (i) {
        return {
            x: 75 + i * 90 + 25,
            y: 93 + 22
        };
    };

ComboLock.prototype.posPad =
    function (i) {
        return {
            x: 76 + i * 89 + 6,
            y: 203 + 5
        };
    };
